import { sanitizeHtml } from '@hen-site/utils/sanitizeHtml';

type FooterSiteMessageProps = {
  html?: string;
};

/**
 * Renders tenant/CMS footer copy that may include inline links.
 * Sanitizes to allowed tags only (`a` + safe hrefs) before injecting HTML.
 */
export function FooterSiteMessage({ html }: FooterSiteMessageProps) {
  const safe = sanitizeHtml(html || '');
  if (!safe) return null;
  return <span dangerouslySetInnerHTML={{ __html: safe }} />;
}
